import { ETimeFrame } from '@sicfe/rooms/types';
import { concatAxiosTransformer } from '../helper';
export default class Controllers {
    constructor(client) {
        this.client = client;
    }
    getRawRoomSensorData(controllerId, payload) {
        return this.client.get(`/controllers/${controllerId}/rooms/${payload.roomId}/raw/${payload.sensor}`, {
            params: {
                from: payload.from,
                to: payload.to,
                interval: (function () {
                    switch (payload.timeFrame) {
                        case (ETimeFrame.HOUR):
                            return '1s';
                        case (ETimeFrame.DAY):
                            return '1m';
                        case (ETimeFrame.WEEK):
                            return '10m';
                    }
                }()),
            },
            transformResponse: concatAxiosTransformer(this.client.defaults.transformResponse, (sensorData) => {
                for (const entity of sensorData) {
                    for (const type of entity.types) {
                        for (const parts of type.values) {
                            for (const value of parts) {
                                value.time = new Date(value.time);
                            }
                        }
                    }
                }
                return sensorData;
            }),
        });
    }
    getSetpointData(controllerId, payload) {
        return this.client.get(`/controllers/${controllerId}/rooms/${payload.roomId}/setpoints/${payload.sensor}`, {
            params: {
                from: payload.from,
                to: payload.to,
                interval: (function () {
                    switch (payload.timeFrame) {
                        case ETimeFrame.HOUR:
                            return '1s';
                        case ETimeFrame.DAY:
                            return '1m';
                        case ETimeFrame.WEEK:
                            return '10m';
                    }
                })(),
            },
            transformResponse: concatAxiosTransformer(this.client.defaults.transformResponse, (sensorData) => {
                for (const parts of sensorData) {
                    for (const data of parts) {
                        data.time = new Date(data.time);
                    }
                }
                return sensorData;
            }),
        });
    }
    getRoomSensorData(controllerId, payload) {
        return this.client.get(`/controllers/${controllerId}/rooms/${payload.roomId}/sensors/${payload.sensor}`, {
            params: {
                from: payload.from,
                to: payload.to,
                interval: (function () {
                    switch (payload.timeFrame) {
                        case ETimeFrame.HOUR:
                            return '1s';
                        case ETimeFrame.DAY:
                            return '1m';
                        case ETimeFrame.WEEK:
                            return '10m';
                    }
                })(),
            },
            transformResponse: concatAxiosTransformer(this.client.defaults.transformResponse, (sensorData) => {
                for (const parts of sensorData) {
                    for (const data of parts) {
                        data.time = new Date(data.time);
                    }
                }
                return sensorData;
            }),
        });
    }
}
